// Imagem de marca.
// - `id` começa por "/" → fotografia oficial servida a partir de /public/assets.
// - `id` nulo → espaço reservado "Imagem oficial em breve" (nunca se substitui por imagem genérica).
export default function Img({ id, alt = "", priority = false, className = "", label, small = false }) {
  if (!id && small) {
    return (
      <div role="img" aria-label={alt} className={`${className} bg-[#15171B] flex items-center justify-center`}>
        <span className="serif-display text-lg text-[#C2A675]/80 font-light">{alt.charAt(0)}</span>
      </div>
    );
  }
  if (!id) {
    return (
      <div role="img" aria-label={alt} data-testid="official-image-placeholder" className={`${className} bg-[#15171B] flex flex-col items-center justify-center text-center p-6`}>
        <span className="w-10 h-px bg-[#C2A675]/70 mb-4" aria-hidden="true" />
        <span className="serif-display text-2xl sm:text-3xl text-white/90 font-light">{alt}</span>
        {label && <span className="mono-tag text-[9px] uppercase tracking-[0.24em] text-[#A8A6A0] mt-3">{label}</span>}
      </div>
    );
  }
  return (
    <img
      src={id}
      alt={alt}
      loading={priority ? "eager" : "lazy"}
      fetchPriority={priority ? "high" : "auto"}
      decoding="async"
      className={className}
    />
  );
}
